import * as React from 'react';
import { noop } from 'vet-bones/utils';

import { ContextMenuData } from 'src/containers/ProjectDiagram/types/contextMenu';

export type DiagramContextMenuValue = [
  ContextMenuData | null,
  (contextMenu: ContextMenuData | null) => void
];

export const ContextMenuContext = React.createContext<DiagramContextMenuValue>([
  null,
  noop,
]);

export const useContextMenu = () => {
  const contextMenu = React.useContext(ContextMenuContext);
  return contextMenu;
};

export const useContextMenuValue = (): DiagramContextMenuValue => {
  const [contextMenu, setContextMenu] = React.useState<ContextMenuData | null>(
    null
  );
  return [contextMenu, setContextMenu];
};
